module.exports = __webpack_public_path__ + "static/media/hand.82468c28.png";